import PDFDefinitionCreator from "./PDFDefinitionCreator";
import {DateFormat} from "../../../date_format";
import ViewTTStore from "../ViewTTStore";
import {defer} from "../../../atUtils";
import PDFParametersFormattingStrategy from './PDFParametersFormattingStrategy'
import {createPdf} from '../../../pdf/utils'

const PDFGenerator = function(){}

PDFGenerator.prototype = _.create(Object.prototype, {
    init: function()
    {
        this.onGenerateBreaker = {needBreak: false};

        this.docDefinitionCreator = new PDFDefinitionCreator();
        return this;
    },

    /**
     * We cant interrupt pdf generated process, but we can interrupt on generate process
     */
    interruptGeneration: function()
    {
        this.onGenerateBreaker.needBreak = true;
    },
    
    _getCreatePDFDefinitionStrategy: function()
    {
        return null;
    },

    _getParametersFormattingStrategy: function(config)
    {
        const dateFormatForFileName = new DateFormat('yyyy-MM-dd')
        return new PDFParametersFormattingStrategy().init(
                {
                    customersProjects: ViewTTStore.getMergedCpList()
                },
                config.dateFormat,
                dateFormatForFileName
        );
    },

    calculateTotalNumberOfPages: function(params)
    {
        return 0;
    },

    generatePDF: function(additionalDataProvider)
    {
        var newBreaker = {
            needBreak: false
        };
        this.onGenerateBreaker = newBreaker;

        var config = ViewTTStore.getDetailsTableConfig();
        var pageData = config.viewByDays ? ViewTTPageUtils.tablePresentDataByDays() : ViewTTPageUtils.tablePresentDataByCP();

        var filter = ViewTTStore.getFilter();
        var user = ViewTTStore.getSelectedUser();
        
        var dateRangeSelection = ViewTTStore.getDateRangeConfig();
        var statuses = ViewTTPageUtils.isFeatureEnabled(Features["TTA"]) ? filter.weekApprovalStatuses : null;
        var cpSelection = filter.cpSelection;
        var storedData = ViewTTStore.getData();
        var cpList = ViewTTStore.getMergedCpList();


        var pdfPrintParameters = ViewTTStore.getPrintParametersForGenerate();
        var getChartSectionConfig = ViewTTStore.getChartSectionConfig();

        var pdfConfig = {
            chartType: ChartType.VERTICAL_BAR,
            getChartSectionConfig: getChartSectionConfig,
            pdfPrintParameters: pdfPrintParameters,
            dateFormat: new DateFormat(SystemSettings.dateFormat),
            storedData: storedData,
            selectorsData: {
                customersProjects: cpList
            },
            selectedParameters: {
                viewByDays: config.viewByDays,
                showTasks: config.showTasks,
                dateParameters: {dateRangeSelection: dateRangeSelection},
                user: user,
                statuses: statuses,
                hierarchicalSelectorsParameters: {
                    customersProjectsSelection: cpSelection
                }
            },
            pdfData: {
                "tableData": pageData,
                "chartImage": null
            }
        };

        var s = this;
        return new Promise(
                function(onComplete)
                {
                    if (s.isNeedRetrieveAdditionalData(pdfConfig))
                    {
                        additionalDataProvider(
                                s.getAdditionalDataConfig(pdfConfig),
                                function(additionalData)
                                {
                                    s.updateConfigWithAdditionalData(pdfConfig, additionalData);
                                    onComplete(pdfConfig);
                                })
                    }
                    else
                    {
                        onComplete(pdfConfig);
                    }
                }
        ).then(
                function (pdfConfig) {
                    return new Promise(function (onComplete, onError){
                        defer(_.bind(onComplete, this, pdfConfig));
                    });
                }
        ).then(
                function(pdfConfig)
                {
                    if (newBreaker["needBreak"])
                    {
                        return Promise.reject(new Error("abort"));
                    }
                    return s._generatePDF(pdfConfig, newBreaker);
                }
        );
    },

    isNeedRetrieveAdditionalData: function(pdfConfig)
    {
        return ViewTTStore.getChartSectionConfig()["showChart"];
    },

    getAdditionalDataConfig: function(pdfConfig)
    {
        return {
            chartImageSizes: this.docDefinitionCreator.getChartImageSizes(pdfConfig.pdfPrintParameters)
        }
    },

    updateConfigWithAdditionalData: function(pdfConfig, additionalData)
    {
        pdfConfig.pdfData.chartImage = additionalData["chartImage"];
    },

    _generatePDF: function(config, breaker)
    {
        var paramFormattingStrategy = this._getParametersFormattingStrategy(config);
        var self = this;

        return this.docDefinitionCreator
                .createDocDefinition(config, paramFormattingStrategy)
                .then(
                        function(ddObject)
                        {
                            var doc = createPdf(ddObject["docDefinition"]);
                            var currentFileName = paramFormattingStrategy.formatChartPDFFileName(config.selectedParameters);

                            return new Promise(function(onComplete, onError)
                            {
                                try
                                {
                                    doc._createDoc(
                                            {
                                                tableLayouts: ddObject["tableLayouts"]
                                            },
                                            function(result, pages)
                                            {
                                                if (breaker.needBreak)
                                                {
                                                    return onError(new Error("abort"));
                                                }
                                                
                                                onComplete({
                                                               encodedPDF: result,
                                                               fileName: currentFileName,
                                                               pageCount: pages.length
                                                           })
                                            }
                                    );

                                }
                                catch (e)
                                {
                                    onError(e);
                                }
                            });
                        }
                );
    }
});

export default PDFGenerator;


// WEBPACK FOOTER //
// ./web/js/user/viewtt/pdf/PDFGenerator.js